import React from 'react'
import DrawerComponent from '../components/drawer'
import {
   Table,
   TableRow,
   TableCell,
   TableContainer
} from '@material-ui/core'
import DropMenu from '../components/dropMenu'

import {TrimWhiteSpace} from '../functions/utils'

export default function NavBar() {

  return (
    <div className="navBar" >
      <TableContainer style={{boxShadow: 'none'}}>
    <Table className="desktopNav"    >
      <TableRow >
        <TableCell style={{borderBottom: 'none'}} >
            <a href="/" style={{color: '#fff', fontSize: '18px'}} >
                Home
              </a>
          
        </TableCell>
        <TableCell style={{borderBottom: 'none'}} >
            <a href="https://issaic.saic.com/sites/innovationfactory/overview" target="_blank" rel="noreferrer" style={{color: '#fff',fontSize: '18px'}} >
              ISSAIC
            </a>
        </TableCell>
        <TableCell style={{borderBottom: 'none'}} >
            <a href="https://saiconline.sharepoint.us/teams/EnterpriseITDIFPortal/SitePages/EITIF.aspx "
              target='_blank'
               style={{color: '#fff',fontSize: '18px'}} >
              Offerings
            </a>
        </TableCell>
        <TableCell style={{borderBottom: 'none'}} >
            <a href={"/demos"}target="_blank" style={{color: '#fff',fontSize: '18px'}} >
              Demos
             </a>
        </TableCell>
        <TableCell style={{borderBottom: 'none'}} >
          <DropMenu
            menuItem={'Digital'}
            itemOne={'Platforms & Cloud'}
            itemTwo={'App Dev'}
            itemThree={'Cyber'}
            itemOneLink={'https://cloud.digital.saicif.com/'}
            itemTwoLink={'https://appdev.digital.saicif.com/'}
            itemThreeLink={'https://cyber.digital.saicif.com/'}
          />
        </TableCell>
        <TableCell style={{borderBottom: 'none'}} >
              <a href="/partnerRelations" style={{color: '#fff',fontSize: '18px'}} >
                    Partners
              </a>
        </TableCell>

        <TableCell style={{borderBottom: 'none'}} >
              <a  href="/faqs" style={{color: '#fff',fontSize: '18px'}} >
                 FAQs
              </a>
        </TableCell>

        <TableCell style={{borderBottom: 'none'}} >
             <a  href="/aboutUs"  style={{color: '#fff',fontSize: '18px'}} >
                 POCs
              </a>
        </TableCell>

      </TableRow>
    </Table>
    </TableContainer>


      <div className="mobileNavMenu">
        
        <DrawerComponent />
      </div>

  
    </div>

  )
}



